import {
    ListType,
    LookupContextMode,
    LookupResultsMode,
    LookupSourceType,
    SystemEntity,
} from '@wdx/clmi/clmi-swagger-gen';
import {
    KeyValueObject,
    LIST_FORM_ID,
    Privilege,
    TRANSLATION_LIST_OVERVIEW_TAB,
    TRANSLATION_TAB_DASHBOARD,
    TRANSLATION_TAB_LIST_MEMBERS,
    TRANSLATION_TAB_NETWORK_CHART,
    TRANSLATION_TABLE_HEADER_MEMBER_COUNT,
    TRANSLATION_TABLE_HEADER_NAME,
    TRANSLATION_TABLE_HEADER_OWNER,
    TRANSLATION_TABLE_HEADER_PURPOSE,
    TRANSLATION_TABLE_HEADER_STATUS,
    TRANSLATION_TABLE_HEADER_TYPE,
} from '@wdx/shared/utils';
import { ICON_ADD } from '../../../../constants/icons.constants';
import {
    ASSIGN_TO_MENU_ITEM,
    ASSIGN_TO_ME_MENU_ITEM,
    SELECT_MENU_ITEM,
} from '../../../../constants/menu.constants';
import { ActionButton } from '../../../../models/action-button.model';
import { ActionButtonMode } from '../../../../models/action-buttons-mode.model';
import { TableHeader } from '../../../../models/table-header.model';

export const LISTS_ROUTE_DATA = {
    viewType: SystemEntity.List,
};

export const LISTS_HEADERS: TableHeader[] = [
    {
        value: 'Name',
        translationKey: TRANSLATION_TABLE_HEADER_NAME,
    },
    {
        value: 'Owner',
        translationKey: TRANSLATION_TABLE_HEADER_OWNER,
    },
    {
        value: 'Type',
        translationKey: TRANSLATION_TABLE_HEADER_TYPE,
    },
    {
        value: 'Member Count',
        translationKey: TRANSLATION_TABLE_HEADER_MEMBER_COUNT,
    },
    {
        value: 'Purpose',
        translationKey: TRANSLATION_TABLE_HEADER_PURPOSE,
    },
    {
        value: 'Status',
        translationKey: TRANSLATION_TABLE_HEADER_STATUS,
    },
    {
        value: null,
    },
];

export const LIST_ROUTE_DATA = {
    label: 'List',
    translationKey: 'List',
    tabsConfig: {
        lookupType: SystemEntity.List,
    },
};

export const CONTEXT_MENU_BUTTON: ActionButton = {
    mode: ActionButtonMode.DropdownButtonMenu,
    cySelector: `btn-context-menu-action`,
    dropdownMenu: [
        SELECT_MENU_ITEM,
        ASSIGN_TO_ME_MENU_ITEM,
        ASSIGN_TO_MENU_ITEM,
    ],
};

export const SEARCH_BAR_ACTION_BUTTONS: ActionButton[] = [
    {
        mode: ActionButtonMode.IconButton,
        icon: ICON_ADD.icon,
        cySelector: 'btn-add',
        privileges: [Privilege.ListCreate],
        formSetup: {
            formId: LIST_FORM_ID,
        },
    },
];

export const LIST_TYPE_ICON_MAP: Record<string, string> = {
    business: 'building',
    compliance: 'clipboard-list-check',
    family: 'user-group',
    standard: 'list',
};

export const LIST_TYPE_LOOKUP_SOURCE_FALLBACK = [
    LookupSourceType.Organisation,
    LookupSourceType.Person,
];

export const LIST_TYPE_LOOKUP_SOURCE_MAP: Record<string, LookupSourceType[]> = {
    business: [LookupSourceType.Client],
    compliance: [
        LookupSourceType.Client,
        LookupSourceType.Organisation,
        LookupSourceType.Person,
    ],
    family: [LookupSourceType.Client],
    standard: [LookupSourceType.Organisation, LookupSourceType.Person],
};

export const LIST_TYPE_LOOKUP_CONTEXT_MODE_MAP: Record<
    string,
    LookupContextMode
> = {
    business: LookupContextMode.SearchIgnoresContext,
    compliance: LookupContextMode.SearchIgnoresContext,
    family: LookupContextMode.SearchPreservesContext,
    standard: LookupContextMode.SearchIgnoresContext,
};

export const LIST_ADD_MEMBER_FORM_INPUT_DATA = (
    id: string,
    label: string,
    listType: { code?: string } | null | undefined,
) => ({
    label,
    id,
    lookupSources:
        (
            LIST_TYPE_LOOKUP_SOURCE_MAP[listType?.code || ''] ??
            LIST_TYPE_LOOKUP_SOURCE_FALLBACK
        )?.map((lookupSource) => ({ type: lookupSource })) ?? [],
    lookupContextMode: LIST_TYPE_LOOKUP_CONTEXT_MODE_MAP[listType?.code || ''],
    lookupResultsMode: LookupResultsMode.Immediate,
});

export const LIST_ADD_MEMBER_CONTEXTUAL_RESULTS = (listId: string) => [
    {
        id: listId,
        lookupType: SystemEntity.List,
    },
];

export const LISTS_FOR_PARTY_FORM_INPUT_DATA = (label: string, id: string) => ({
    label,
    id,
    lookupSources: [{ type: LookupSourceType.List }],
    lookupContextMode: LookupContextMode.SearchPreservesContext,
    lookupResultsMode: LookupResultsMode.Immediate,
});

export const LISTS_FOR_PARTY_CONTEXTUAL_RESULTS = (
    partyId: string,
    lookupType: LookupSourceType = LookupSourceType.Party,
) => [
    {
        id: partyId,
        lookupType,
    },
];
export const TAB_ROUTE_MAP: Record<string, string> = {
    appListOverview: 'overview',
    appDashboard: 'dashboard',
    appNetworkChart: 'network',
};

export const TAB_CONFIG = [
    {
        tabId: 'appListOverview',
        translationKey: TRANSLATION_LIST_OVERVIEW_TAB,
        default: true,
        condition: () => true,
    },
    {
        tabId: 'appDashboard',
        translationKey: TRANSLATION_TAB_DASHBOARD,
        default: true,
        condition: (listType: ListType) => listType.code !== 'standard',
    },
    {
        tabId: 'appNetworkChart',
        translationKey: TRANSLATION_TAB_NETWORK_CHART,
        default: true,
        condition: (listType: ListType) =>
            listType.code !== 'standard' && listType.code !== 'compliance',
    },
];
